import React from 'react';
import { Box, Stack } from '@mui/material';

// components
import SignUpStepper from 'src/components/stepper';

interface PaymentPageHeaderProps {
  isMobile: boolean;
  showTwoStepProcess: boolean;
}

export const PaymentPageHeader: React.FC<PaymentPageHeaderProps> = ({
  isMobile,
  showTwoStepProcess,
}) => {
  return (
    <Stack mb={isMobile ? '24px' : '64px'} alignItems={'center'}>
      <Box width={showTwoStepProcess ? 70 : 100}>
        <SignUpStepper
          activeStep={showTwoStepProcess ? 2 : 3}
          steps={showTwoStepProcess ? ['1', '2'] : ['1', '2', '3']}
        />
      </Box>
      <Stack alignItems={'center'}>
        <Box
          textAlign={'center'}
          sx={{
            fontSize: isMobile ? '20px' : '29px',
            fontWeight: 800,
            marginTop: '20px',
          }}>
          {isMobile ? 'Order Summary' : 'Complete payment'}
        </Box>
      </Stack>
    </Stack>
  );
};
